<ipo-modal [heading]="'guide.userGuide' | translate" (dismiss)="onDismiss()">
  @if (availableGuides$ | async; as availableGuides) {
    @if (selectedGuide$ | async; as selectedGuide) {
      <div class="container">
        @if (!showMenu) {
          <app-guide-text
            [text]="
              getSelectedGuideText(
                availableGuides[selectedGuide.key],
                selectedGuide.selectedSubMenuIndex
              )
            "
            [showNext]="showNext"
            (nextTextClicked)="onNextTextClick()"
          ></app-guide-text>
        }
      </div>
    }
  }
</ipo-modal>
